<template lang="pug">
    .play-box(
        v-if='!isOlympiad || (isOlympiad && !gameEnd)',
    )
        .mult-div__trainer-loader(v-if='isSingleScreen && !isSoundsLoaded')
            progress(:value='this.loadedSound/this.soundObjects.length * 100' max='100')
                | {{ this.loadedSound / this.soundObjects.length * 100 }}%
            |   {{ $i18n.t('trainer.trainer_gamePlayBox_gameLoading') }}
        template
            game-header(
                :answers='answers'
                :time="getTime"
                :slug='type'
                :is-single-screen="isSingleScreen"
                :game-type='parameters && parameters.courseType'
                :is-game-paused="isGamePaused"
                :color-for-student="colorForStudent"
                :index-of-play-box="place - 1"
                :game-end="gameEnd"
                @soundStateChanged="headerKey = !headerKey"
                :key="headerKey"
                :is-homework="!!exerciseId"
            )
            .play-box__game
                svg-icon.pause-icon(v-if="isGamePaused", name="pause" height="50px" width="50px")
                .roots-and-degrees__container(v-else)
                    portal-target(name="abacusDestination", v-if="!isMultiplayer")
                    .roots-and-degrees__container_body
                        example(
                            :key="parametersChangerCounter"
                            v-if='startGame || isBattle'
                            :example='example'
                            :parameters='parameters'
                            @getAnswer='answerValue'
                            @checkAnswer='checkAnswer'
                            :is-battle="isBattle"
                            :correct="correct"
                            :start-game="startGame"
                        )
                        .mult-div__show-answer-button(v-if='false')
                            img.mult-div__answer-turtle(:src="turtle")
                            cs-button(@click='showAnswer' v-focus='')
                                | {{ $i18n.t('trainer.trainer_gamePlayBox_showAnswers') }}

                        result(
                            v-if="!startGame"
                            @restart='refreshGame'
                            :answer='answer'
                            :exercise-id='exerciseId'
                            @clearAnswer='clearAnswer'
                            :right-answer='rightAnswer'
                            :game-end='gameEnd'
                            :place='place'
                            :is-single-screen='isSingleScreen'
                            :show-problem="showProblem"
                            @showProblem="showProblem = $event"
                            :is-olympiad="isOlympiad"
                            :example='example'
                            :color-for-student="colorForStudent"
                        )
                            slot
                .game-info__container
                    .game-info__block
                        game-info(
                            v-if="startGame",
                            :score="{left: !isBattle ? answers.good : userScore, right: !isBattle ? answers.bad : opponentScore}",
                            :time="getTime",
                            :time-with-hours="getTimeWithHours",
                            :mode="parameters && parameters.mode",
                            :game-difficult="gameDifficult",
                            :player-name="parameters && parameters.playerName",
                            :place="place",
                            :color-for-student="colorForStudent",
                            @openModalFrame="showModalFrame = true",
                            :is-game-paused="isGamePaused",
                            :is-olympiad="isOlympiad",
                            :slug="type",
                            @parametersUpdate="handleParametersUpdate",
                            :is-from-battle="isBattle",
                            :parameters="parameters",
                            :opponent="opponent",
                            :opponent-numbers="opponentNumbers",
                            :is-opponent-answering="isOpponentAnswering",
                            :digit-capacity="{digitCapacity: gameDifficult}"
                            :abacus-to-portal="true",
                        )
        calculating-answers(v-if="calculatingAnswers" :is-last-game-in-battle="isLastGameInBattle")
</template>

<script>
    const AVAILABLE_ANSWERS_DIRS = ['ru', 'fr'];
    const SECONDS_IN_MINUTE = 60;
    import MultiplayerPlayBoxMixin from '../../../../utils/multiplayer/playBoxMixin';
    import trainerConfig from '../../../../config/trainer';
    import GameMixin from '../../../../utils/trainer/game';
    import GenerateExample from '../../../../utils/roots-and-degrees/generateExample';
    import Example from './Example.vue';
    import Result from './Result.vue';
    import timer from '../../../../utils/trainer/timer';
    import GameHeader from '../../GameHeader.vue';
    import answerDurationMixin from '../../../../utils/trainer/answerDurationMixin';
    import EndGameMixin from '../utils/endGame';
    import _ from 'lodash';
    import GamePreparationCounter from '../../GamePreparationCounter.vue';
    import GameInfo from '../GameInfo.vue';
    import Battle from '../../../../utils/battle/battleMixin';
    import CalculatingAnswers from '../../CalculatingAnswersModal.vue';
    import RootsAndDegreesExamplesViewer from '../RootsAndDegreesExamplesViewer.vue';
    export default {
        props: {
            exerciseId: {
                type: Number,
                default: 0,
            },
            type: {
                type: String,
                default: '',
            },
            gameType: {
                type: String,
                default: '',
            },
            playAgain: {
                type: Boolean,
                default: false,
            },
            inPuzzle: {
                type: Boolean,
                default: false,
            },
            isLastGameInBattle: {
                type: Boolean,
                default: false,
            },
            isMultiplayer: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                answers: {
                    good: 0,
                    bad: 0,
                },
                parameters: null,
                example: null,
                answer: null,
                rightAnswer: null,
                startGame: true,
                gameEnd: false,
                counter: 0,
                correct: null,
                answerTimer: null,
                answerTime: 0,
                examplesArray: [],
                ableToShowButton: false,
                ableToShowAnswers: false,
                examplesPlayed: 0,
                loadedSound: 0,
                isSoundsLoaded: false,
                headerKey: false,
                showProblem: false,
                infinityModeCompleted: false,
            };
        },
        mixins: [GameMixin, GenerateExample, timer, answerDurationMixin, EndGameMixin, Battle, MultiplayerPlayBoxMixin],
        beforeDestroy() {
            if (!this.inPuzzle) {
                this.$createjs.Sound.removeAllSounds();
                this.$createjs.Sound.removeAllEventListeners();
            }
            this.beforeTabClosed();
            window.removeEventListener('beforeunload', this.beforeTabClosed);
        },
        created() {
            window.addEventListener('beforeunload', this.beforeTabClosed);
        },
        mounted() {
            this.fetchData().then(() => {
                if (!this.isSingleScreen) {
                    this.isGamePaused = true;
                } else if (this.inPuzzle) {
                    this.isSoundsLoaded = true;
                } else if (this.soundObjects) {
                    this.$createjs.Sound.removeAllEventListeners();
                    this.$createjs.Sound.addEventListener('fileload', this.soundLoad);
                    this.$createjs.Sound.alternateExtensions = ['mp3'];
                    this.$createjs.Sound.registerSounds(this.soundObjects);
                }
                if (this.parameters.randomDate) {
                    this.example = this.generateRandomDate();
                }
                this.trackTime();
                this.parameters?.timeForAnswer && this.startAnswerTimer();
                this.setTimer();
            });
        },
        watch: {
            isTimeOver(val) {
                if (val) {
                    this.gameEnd = true;
                    this.startGame = false;
                    if (!this.isBattle) {
                        this.$toasted.info(this.$i18n.t('trainer.trainer_gamePlayBox_gameCompleted'));
                        this.checkAnswer(this.answer);
                    } else {
                        this.sendStat(false);
                    }
                }
            },
            gameEnd(val) {
                if (val) {
                    this.$emit('playAgainReady', !this.isSingleScreen);
                    if (this.inPuzzle) {
                        this.$emit('finish', this.answers, this.time, this.example);
                    }
                }
            },
            correct(val) {
                if (this.isSingleScreen) {
                    this.$emit('playAgainReady', val !== null);
                } else {
                    let playBox = document.querySelectorAll('.play-box')[this.place - 1].parentElement;
                    if (playBox) {
                        if (val !== null && val) {
                            playBox.classList.add('play-box__correct-answer');
                        } else if (val !== null && !val) {
                            playBox.classList.add('play-box__incorrect-answer');
                        } else if (val === null) {
                            playBox.classList.remove('play-box__correct-answer');
                            playBox.classList.remove('play-box__incorrect-answer');
                        }
                    }
                }
            },
            startGame: {
                handler(val) {
                    if (this.parameters && this.parameters.dictation && !val) {
                        return;
                    }
                    val ? this.setTimer() : clearTimeout(this.timer);
                    this.$emit('checkAnswersReady', { status: val, playerPosition: this.place });
                },
            },
            playAgain(val) {
                if (val && this.answers.good < this.parameters.amountOfExamples && !this.startGame) {
                    this.refreshGame();
                }
            },
            multiplayerGamesState(value) {
                if (value && !this.gameEnd) {
                    this.isGamePaused = value === 'paused';
                }
            },
            isGamePaused(value) {
                if (!value) {
                    this.counter = 1;
                } else {
                    this.startGame = false;
                    this.stopTimer();
                }
                let playBox = document.querySelectorAll('.play-box')[this.place - 1]?.parentElement;
                if (playBox) {
                    playBox.classList.remove('play-box__correct-answer');
                    playBox.classList.remove('play-box__incorrect-answer');
                }
            },
            refreshGameEvent: {
                handler() {
                    this.resetGameResult();
                },
                immediate: true,
            },
            continueGameEvent(val) {
                if (
                    val &&
                    !this.startGame &&
                    (this.answers.good < this.parameters.amountOfExamples || this.parameters.infinityAmountOfExamples)
                ) {
                    this.refreshGame();
                }
            },
            parametersChangerCounter() {
                if (!this.gameEnd) {
                    this.time = 0;
                    this.correct = null;
                }
                this.fetchData().then(this.generateExample);
            },
        },
        methods: {
            resetGameResult() {
                if (!this.isSingleScreen) {
                    this.isGamePaused = true;
                }
                this.answers.good = 0;
                this.answers.bad = 0;
                this.correct = null;
                this.examplesArray = [];
                this.showProblem = false;
                this.answer = null;
                this.gameEnd = false;
                this.stopTimer();
                this.time = 0;
                clearInterval(this.answerTimer);
                this.answerTime = 0;
            },
            generateRandomDate() {
                let randomDate;
                do {
                    randomDate = this.getRandomDate();
                } while (this.parameters.isLeapYear && randomDate.getFullYear() % 4 !== 0);
                return randomDate.toLocaleDateString('ru');
            },
            getRandomDate() {
                const START_DATE = new Date(1600, 1, 1);
                return new Date(START_DATE.getTime() + Math.random() * (new Date().getTime() - START_DATE.getTime()));
            },
            soundLoad() {
                this.loadedSound++;
                if (this.loadedSound === this.soundObjects.length) {
                    this.isSoundsLoaded = true;
                    this.counter = 1;
                }
            },
            startAnswerTimer() {
                this.answerTimer = setInterval(() => {
                    if (this.startGame) {
                        this.answerTime++;
                        if (this.answerTime === this.parameters.timeForAnswer) {
                            if (this.parameters.dictation) {
                                this.ableToShowAnswers = false;
                            } else {
                                this.checkAnswer(this.answer);
                                this.startGame = false;
                                return;
                            }
                            this.refreshGame();
                        }
                    }
                }, 1000);
            },
            clearAnswer() {
                this.answer = null;
            },
            checkAnswer(answer) {
                this.answer = answer ? answer : this.answer;
                const dateString = this.parameters.date ? this.parameters.date : this.example;
                const dateParts = dateString.split('.');
                this.rightAnswer = new Date(
                    dateParts[2],
                    parseInt(dateParts[1]) - 1,
                    dateParts[0]
                ).toLocaleDateString(this.user.locale, { weekday: 'long' });
                if (this.answer) {
                    this.answer = this.answer.toLowerCase();
                }
                if (this.answer === this.rightAnswer) {
                    this.correct = true;
                    this.answers.good++;
                    this.example = this.generateRandomDate();
                    if (
                        !this.isOlympiad &&
                        !this.isBattle &&
                        this.answers.good >= this.parameters.amountOfExamples &&
                        !this.parameters.infinityAmountOfExamples
                    ) {
                        this.gameEnd = true;
                    }
                } else {
                    this.correct = false;
                    this.answers.bad++;
                }
                this.stopTracking();
                if (
                    (this.isOlympiad || this.isBattle) &&
                    this.answers.good + this.answers.bad >= this.parameters.amountOfExamples
                ) {
                    this.gameEnd = true;
                }
                if (!this.$offline && (this.user.type === 'student' || this.user.type === 'olympiads-student')) {
                    this.sendStat(this.correct);
                }
                if (this.isOlympiad) {
                    this.refreshGame();
                } else {
                    this.startGame = false;
                }
                this.startGame = false;
            },
            answerValue(answer) {
                this.answer = answer;
            },
            refreshGame(playAgain = false) {
                if (playAgain) {
                    this.resetGameResult();
                }
                if (this.parameters.timeForAnswer !== -1) {
                    this.examplesPlayed++;
                    clearInterval(this.answerTimer);
                    this.answerTime = 0;
                    this.examplesArray.push(_.cloneDeep(this.example));
                    this.startGame = true;
                    if (this.examplesPlayed >= this.parameters.amountOfExamples) {
                        this.ableToShowButton = true;
                        this.example = this.generateRandomDate();
                    } else if (this.answers.good === this.parameters.amountOfExamples) {
                        this.gameEnd = true;
                    } else {
                        this.example = this.generateRandomDate();
                    }
                    if (!this.ableToShowButton) {
                        clearTimeout(this.timer);
                        this.timer = null;
                    }
                    this.startAnswerTimer();
                    return;
                }
                this.showProblem = false;
                this.answer = null;
                this.correct = null;
                this.startGame = true;
                this.isOpponentAnswering = false;
                this.trackTime();
            },
            showAnswer() {
                this.ableToShowAnswers = true;
                this.ableToShowButton = false;
                clearTimeout(this.timer);
                this.timer = null;
            },
            beforeTabClosed() {
                if (
                    (this.startGame || (!this.startGame && !this.gameEnd && this.correct !== null)) &&
                    this.user.type === 'student' &&
                    !this.isBattle
                ) {
                    this.gameEnd = true;
                    this.infinityModeCompleted = true;
                    this.sendStat(true);
                }
                return null;
            },
        },
        computed: {
            isTimeOver() {
                return (
                    this.parameters &&
                    this.parameters.timeLimit &&
                    this.time >= this.parameters.timeLimit * SECONDS_IN_MINUTE
                );
            },
            soundObjects() {
                if (!this.isSingleScreen) {
                    return;
                }
                return trainerConfig.result;
            },
            locale() {
                if (this.user && this.user.locale) {
                    return this.user.locale;
                }
                return 'ru';
            },
            turtle() {
                if (AVAILABLE_ANSWERS_DIRS.includes(this.locale)) {
                    return require(`../../../../assets/images/turtle/${this.locale}/${this.locale}_AnswerTurtle.svg`);
                }
                return require(`../../../../assets/images/turtle/ru/ru_AnswerTurtle.svg`);
            },
            isOlympiad() {
                return this.gameType === 'olympiad';
            },
            isSingleScreen() {
                return true;
            },
            gameDifficult() {
                return this.parameters?.digitCapacity;
            },
        },
        components: {
            Example,
            Result,
            GameHeader,
            GamePreparationCounter,
            GameInfo,
            CalculatingAnswers,
            RootsAndDegreesExamplesViewer,
        },
    };
</script>

<style scoped lang="scss">
    @import '@/assets/sass/games/playbox.scss';

    .mult-div__show-answer-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        @include inset-space($space-base);
    }

    .mult-div__answer-turtle {
        max-width: 180px;
        @include stack-space($space-base);
        @include media($xlg) {
            max-width: 240px;
        }
    }

    .mult-div__prepare-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        flex-shrink: 1;
        justify-content: center;
        align-items: center;
        @include inset-space($space-base);
    }

    .mult-div__prepare-text {
        font-family: Boomboom, serif;
        color: $color-brown-500;
        font-size: 30px;
        white-space: nowrap;

        @include media($sm) {
            font-size: 60px;
        }
    }

    .play-box__game {
        display: flex;
        flex: 1 1 auto;
        justify-content: center;
        align-items: center;
    }

    .pause-icon {
        color: $x-color-white;
        background-color: $hsl-color-blue-56_5;
        border-radius: 50%;
    }

    .roots-and-degrees__container {
        display: flex;
        flex-grow: 1;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .roots-and-degrees__container_body {
        margin-top: 24px;
    }

    .mult-div__trainer-loader {
        @include make-col(8, 12, 0);
        @include make-offset(2, 12);
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        height: 100%;
    }

    .mult-div__divider {
        border-bottom: 1px solid $color-grey-300;
    }

    .game-info {
        align-self: flex-start;
    }

    .game-info__container {
        display: flex;
        align-self: start;
        flex-direction: column;
        margin-bottom: 20px;
    }

    .game-info__block {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        align-self: flex-start;
    }
</style>

<style lang="scss" scoped>
    .multiplayer .play-box__game {
        height: 100%;
        flex-direction: column-reverse;
        justify-content: flex-end;
        align-items: center;
    }

    .multiplayer .game-info__container {
        align-self: auto;
    }

    .multiplayer .roots-and-degrees__container {
        width: 100%;
    }
</style>
